import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export interface CostCodeBoxStyledProps {
  isRestricted: boolean;
}

export const CostCodeBoxStyled = styled(Box).attrs({
  px: { sm: '500' },
  py: { sm: '450' },
})<CostCodeBoxStyledProps>`
  ${({ theme, isRestricted }) =>
    css`
      border-bottom: 1px solid ${theme.colors.grey[300]};
      ${isRestricted &&
      css`
        pointer-events: none;
        opacity: 0.5;
      `};
    `}
`;

export const LabelStyled = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
`;
